import React from 'react';
const MaintenanceContext = React.createContext();
MaintenanceContext.displayName = 'maintenanceContext';
export default MaintenanceContext;
